import { Injectable, signal } from '@angular/core';

export interface AssistantPageContext {
  description: string;
  value: unknown;
}

@Injectable({ providedIn: 'root' })
export class AssistantContextService {
  readonly pageContext = signal<AssistantPageContext | null>(null);

  set(ctx: AssistantPageContext): void {
    this.pageContext.set(ctx);
  }

  clear(): void {
    this.pageContext.set(null);
  }
}
